import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { MenuSettings } from "../models/menu-settings";
import { ServiceBase } from "./service-base";

@Injectable({
  providedIn: "root",
})
export class SettingsService extends ServiceBase {
  constructor(private http: HttpClient) {
    // Appelle le constructeur de la classe mère ServiceBase
    super();
  }

  // Méthode pour récuperer les paramètres du menuSettings
  getSettings(): Observable<MenuSettings> {
    return this.http.get<MenuSettings>(`${this.apiUrl}/api/domain/configuration`);
  }
}
